/**
 * @file Re-exports the Plaid connect modal.
 */
import PlaidModal from "./PlaidModal";

export default PlaidModal;
